import type { Product, SaleEvent } from '../types/catalog'

export const bestSellers: Product[] = [
  {
    id: 'cuban-link-bracelet',
    name: 'Classic Cuban Link Chain Bracelet',
    detail: '18K Italian Gold · Cuban link',
    price: '$380',
    image:
      'https://cdn.magicpatterns.com/uploads/jRE4HBj7u1TAVTt6NAvGzw/Classic_cuban_link_chain_bracelet_(1).jpg',
  },
  {
    id: 'diamond-cut-ball-earring',
    name: 'Diamond-Cut Yellow Gold Ball Earring',
    detail: '18K Gold · Diamond-cut finish',
    price: '$185',
    image:
      'https://cdn.magicpatterns.com/uploads/fBXfSo1fFrPtD4LiBaquR9/Diamond-cut_yellow_gold_ball_earring_(1).jpg',
  },
  {
    id: 'rosary-necklace-50',
    name: 'Italian 18K Gold Rosary Necklace 50 cm',
    detail: '18K Italian Gold · Tri-tone beads · 50 cm',
    price: '$681',
    image:
      'https://cdn.magicpatterns.com/uploads/c4DFJWNDA2xpFNGhFeM7KZ/Italian_18k_gold_rosary_necklace_50_cm_(1).jpg',
  },
  {
    id: 'emerald-earring',
    name: 'Yellow Gold Emerald Earring',
    detail: '18K Gold · Emerald stones',
    price: '$520',
    image:
      'https://cdn.magicpatterns.com/uploads/2Hv2WPGmf2GkNBttUU1H5e/yellow_gold_emerald_earring_(1).jpg',
  },
]

export const liveSales: SaleEvent[] = [
  {
    id: 'sale-1',
    city: 'New York, NY',
    product: 'Italian 18K Gold Rosary Necklace 50 cm',
    minutesAgo: 2,
    image:
      'https://cdn.magicpatterns.com/uploads/c4DFJWNDA2xpFNGhFeM7KZ/Italian_18k_gold_rosary_necklace_50_cm_(1).jpg',
  },
  {
    id: 'sale-2',
    city: 'Ridgewood, NY',
    product: 'Classic Cuban Link Chain Bracelet',
    minutesAgo: 6,
    image:
      'https://cdn.magicpatterns.com/uploads/jRE4HBj7u1TAVTt6NAvGzw/Classic_cuban_link_chain_bracelet_(1).jpg',
  },
  {
    id: 'sale-3',
    city: 'Brooklyn, NY',
    product: 'Yellow Gold Emerald Earring',
    minutesAgo: 11,
    image:
      'https://cdn.magicpatterns.com/uploads/2Hv2WPGmf2GkNBttUU1H5e/yellow_gold_emerald_earring_(1).jpg',
  },
  {
    id: 'sale-4',
    city: 'Queens, NY',
    product: 'Diamond-Cut Yellow Gold Ball Earring',
    minutesAgo: 17,
    image:
      'https://cdn.magicpatterns.com/uploads/fBXfSo1fFrPtD4LiBaquR9/Diamond-cut_yellow_gold_ball_earring_(1).jpg',
  },
]
